import React from 'react';
import PropTypes from 'prop-types';
import Title from './Modules/Title';
import List from './Modules/List';
import RichText from './Modules/RichText';

export default function Modules({ reactModule, type }) {
  switch (type) {
    case 'list':
      return <List data={reactModule} />;
    case 'richText':
      return <RichText data={reactModule} />;

    default:
      return <div>{type}</div>;
  }
}

Modules.propTypes = {
  reactModule: PropTypes.any,
  type: PropTypes.any,
};
